import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  AutoComplete,
  Tabs,
  Icon,
  message,
  Tooltip
} from 'antd'
import styled from 'styled-components'
import Loader from '../../util/Loader'
import CreateContactForm from '../../components/CreateContactForm'
import { actions as contactActions } from '../../redux/modules/leadFunctions/leadContactActions'
import { actions as organizationsActions } from '../../redux/modules/organizationsActions'
import {
  filterCaseInsensitive,
  listEmails,
  listEmailBarebones,
  listPhoneNumbers,
  listPhoneNumbersBarebones,
  convertNamesToOption
} from '../../util'
import history from '../../history'
import OrganizationQuickAdd from '../../components/organization/OrganizationQuickAdd'
import _ from 'lodash'

import * as authSelectors from '../../selectors/auth'

const TabPane = Tabs.TabPane
const FormItem = Form.Item
const propTypes = {}
const ListBox = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
`
class LeadContact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      tabKey: '1',
      showOkButton: false
    }
  }

  componentDidMount() {
    this.props.leadContactsRefresh({
      leadId: this.props.leadId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row
    })
  }

  handleAddButton = () => {
    this.props.getAllLeadContacts()
    this.props.getAllOrganizations()
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    if (this.state.tabKey === '2') {
      this.setState({
        tabKey: '1'
      })
    }
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.addLeadContact({
          leadId: this.props.leadId,
          content: values,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateLeadContact({
          leadId: this.props.leadId,
          contactId: this.state.currentId,
          content: values,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.removeLeadContact({
      contactId: this.state.currentId,
      leadId: this.props.leadId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleChangeTab = key => {
    this.setState({
      showOkButton: +key === 2 ? true : false
    })

    this.setState({
      tabKey: key
    })
  }

  handleCreateContact = contact => {
    this.props.createContact(contact)
    this.setState({
      tabKey: '1',
      showOkButton: false
    })
    this.props.getAllLeadContacts()
  }

  handleUpdateLeadPrimaryContact = contactId => {
    this.props.updateLeadPrimaryContact({
      contactId: contactId,
      leadId: this.props.leadId
    })
  }

  handleEditLeadContact = () => {
    history.push(`/contacts/${this.state.currentId}`)
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.user.userId
    })
    setTimeout(() => {
      this.props.getAllOrganizations()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.organizationsActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.organizationsActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  render() {
    const { contentData } = this.state

    const allContacts =
      this.props.leadContactActions &&
      this.props.leadContactActions.allContacts &&
      this.props.leadContactActions.allContacts.data

    const { getFieldDecorator } = this.props.form
    if (!this.props.leadContactActions.leadContacts) {
      return <Loader />
    }
    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.handleQuickAddOrganization}
        />
        <Modal
          visible={this.state.modalVisible}
          title="Contacts"
          okText={contentData ? 'Close' : 'Add Contact'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          okButtonProps={{ disabled: this.state.showOkButton }}
          width={700}
          maskClosable={false}
        >
          {contentData && (
            <div>
              <div className="row">
                <div className="col-12">
                  <ul className="list-group">
                    {contentData.title && (
                      <li className="list-group-item d-flex justify-content-between align-items-center">
                        {contentData.title}
                        <span className="badge badge-primary badge-pill">title</span>
                      </li>
                    )}
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <strong>{`${contentData.first_name} ${contentData.last_name}`}</strong>
                      <span className="badge badge-primary badge-pill">name</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      {contentData.organization_name}
                      <span className="badge badge-primary badge-pill">organization</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div>Emails: </div>
                  <ListBox>{listEmails(contentData.email_list)}</ListBox>
                </div>
                <div className="col-md-6">
                  <div>Phone Numbers: </div>
                  <ListBox>{listPhoneNumbers(contentData.phone_list)}</ListBox>
                </div>
              </div>
            </div>
          )}
          {!contentData && (
            <Tabs
              defaultActiveKey="1"
              activeKey={this.state.tabKey}
              onChange={this.handleChangeTab}
            >
              <TabPane tab="Select" key="1">
                <Form layout="vertical">
                  <div className="row">
                    <div className="col-md-12">
                      <FormItem label="Contact">
                        {getFieldDecorator('contact', {
                          rules: [
                            {
                              required: true,
                              message: 'Find your contact'
                            }
                          ],
                          initialValue: contentData ? contentData.contact : ''
                        })(
                          <AutoComplete
                            dataSource={convertNamesToOption(allContacts)}
                            style={{ width: 320 }}
                            filterOption={(inputValue, option) =>
                              option.props.children
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            placeholder="Search for a contact"
                          >
                            <Input
                              suffix={<Icon type="search" className="certain-category-icon" />}
                            />
                          </AutoComplete>
                        )}
                      </FormItem>
                    </div>
                  </div>
                </Form>
              </TabPane>
              <TabPane tab="Create" key="2">
                <CreateContactForm
                  contentData={this.state.contentData}
                  allOrganizations={
                    this.props.organizationsActions &&
                    this.props.organizationsActions.payload &&
                    this.props.organizationsActions.payload.data
                  }
                  createContact={this.handleCreateContact}
                  user={this.props.user}
                  handleBlurOrganization={this.handleBlurOrganization}
                />
              </TabPane>
            </Tabs>
          )}
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.confirmDelete}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            {contentData && <Button type="danger" icon="delete" />}
          </Popconfirm>{' '}
          {contentData && (
            <Button type="primary" onClick={() => this.handleEditLeadContact()} icon="edit">
              View / Edit Contact
            </Button>
          )}
        </Modal>
        <div className="jobsBar">
          Lead Contacts
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Contact
            </div>
          </div>
        </div>
        {this.props.leadContactActions.leadContacts && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: () => {
                if (column.Header !== 'Primary') {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={this.props.leadContactActions.leadContacts.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Title',
                    id: 'title',
                    accessor: 'title',
                    width: 230,
                    Cell: d => <Tooltip title={d.original.title}>{d.original.title}</Tooltip>
                  },
                  {
                    Header: 'Name',
                    id: 'name',
                    accessor: r => `${r.first_name} ${r.last_name}`,
                    width: 200,
                    Cell: d => {
                      const r = `${d.original.first_name} ${d.original.last_name}`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Email',
                    accessor: d => listEmailBarebones(d.email_list),
                    id: 'email_list',
                    Cell: row => {
                      const r = listEmails(row.original.email_list)
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Organization Name',
                    id: 'organization_name',
                    accessor: 'organization_name',
                    Cell: d => (
                      <Tooltip title={d.original.organization_name}>
                        {d.original.organization_name}
                      </Tooltip>
                    )
                  },
                  {
                    Header: 'Phone Number',
                    id: 'phone_number',
                    width: 250,
                    accessor: row => {
                      return row.phone_list.length > 0
                        ? listPhoneNumbersBarebones(row.phone_list)
                        : null
                    },
                    Cell: row => {
                      const r =
                        row.original.phone_list.length > 0
                          ? listPhoneNumbers(row.original.phone_list)
                          : null
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Primary',
                    accessor: 'primary',
                    Cell: d => (
                      <div>
                        <Popconfirm
                          title="Are you sure you want to make this the primary address for this company?"
                          onConfirm={() => this.handleUpdateLeadPrimaryContact(d.original.id)}
                          onCancel={this.cancelDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button
                            size="small"
                            icon={d.original.primary_contact === d.original.id ? 'check' : 'close'}
                            type="link"
                            style={{ color: '#1F45B4' }}
                          />
                        </Popconfirm>
                      </div>
                    ),
                    width: 100
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadContactActions: state.leadContactActions,
  organizationsActions: state.organizationsActions,
  user: authSelectors.getUser(state, props)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, contactActions, organizationsActions), dispatch)
})

LeadContact.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(LeadContact)))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadContacts.container.js